import '.h{width:100%;}.ssr-plugin'
import '.dk{height:4px;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.af{gap:12px;}.ssr-plugin'
import '.dl{align-items:flex-start;}.ssr-plugin'
import '.ac{align-self:stretch;}.ssr-plugin'
import '.dm{border-radius:999px;}.ssr-plugin'
import '.dn{opacity:0.15;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.do{transition:width 120ms ease-out;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.dp{left:0px;}.ssr-plugin'
import '.dq{top:0px;}.ssr-plugin'
import '.de{padding:24px;}.ssr-plugin'
import '.bh{position:fixed;}.ssr-plugin'
import '.z{bottom:0px;}.ssr-plugin'
import '.dr{right:0px;}.ssr-plugin'
import '.k{margin:0 auto;}.ssr-plugin'
import '.dd{max-width:1280px;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.ds{gap:48px;}.ssr-plugin'
import '.bc{align-items:start;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import { FC } from 'react'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { Link } from 'wouter'
import { styled } from 'inlines'
import { useAppCtx } from '../providers/useAppCtx'
import { formatCurrency } from '@/apps/cms/utils/misc'
import { useTranslations } from '../hooks/useTranslations'

type CartItemsIndicatorProps = {
  cartItems?: number
  cartItemsMax?: number
  cartItemsMin?: number
  color?: string
}

export const CartItemsIndicator: FC<CartItemsIndicatorProps> = ({
  cartItems = 0,
  cartItemsMax = 0,
  cartItemsMin = 0,
  color = '#FFFFFF',
}) => {
  const ratio =
    cartItemsMax && cartItemsMax > 0 ? Math.min(cartItems / cartItemsMax, 1) : 0

  const widthMinVotesBar = Math.floor((cartItemsMin / cartItemsMax) * 100)
  const diff = cartItemsMax - cartItemsMin

  const ratioForSecondBar =
    cartItems >= cartItemsMin ? ((cartItems - cartItemsMin) / diff) * 100 : 0

  return cartItemsMin && cartItemsMin > 1 ? (
    <div className="h dk n a af"
    >
      {/* minvotes bar */}
      <div className="dk n"
        style={{
          width: widthMinVotesBar + '%',}}
      >
        <div className="a dk dl ac dm dn bj"
          style={{
            background: color,}}
        ></div>
        <div className="dk dm do p dp dq"
          style={{
            width:
              cartItems < cartItemsMin
                ? `${(cartItems / cartItemsMin) * 100}%`
                : '100%',
            background: color,}}
        />
      </div>

      {/* second bar */}
      <div className="dk n"
        style={{
          width: `calc(100% - ${widthMinVotesBar}%`,}}
      >
        <div className="a dk dl ac dm dn bj"
          style={{
            background: color,}}
        ></div>
        <div className="dk dm do p dp dq"
          style={{
            width: `${ratioForSecondBar}%`,
            background: color,}}
        />
      </div>
    </div>
  ) : (
    <div className="h dk n"
    >
      <div className="a dk dl ac dm dn bj"
        style={{
          background: color,}}
      ></div>
      <div className="dk dm do p dp dq"
        style={{
          width: `${ratio * 100}%`,
          background: color,}}
      />
    </div>
  )
}

export const CartBar: FC = () => {
  const { colors } = useTheme()

  const {
    votesCount,
    activeLanguage,
    price,
    currency,
    maxVotes,
    minVotes = 0,
  } = useAppCtx()
  const { data: cartTranslations } = useTranslations('cart')

  const priceLabel = formatCurrency(
    (votesCount * price) / 100,
    currency,
    activeLanguage,
  )

  return (
    <div className="h de bh z dr dp"
      style={{
        background: colors.primaryAccent,}}
    >
      <div className="k h dd a ae d ds"
      >
        <div className="h bc a i af"
        >
          <CartItemsIndicator
            cartItems={votesCount}
            cartItemsMax={maxVotes}
            cartItemsMin={minVotes}
            color={colors.background}
          />

          <Text variant="display-regular" color={colors.background}>
            {minVotes && votesCount < minVotes
              ? cartTranslations?.minVotes_indicator
              : `${cartTranslations?.counting_votes_indicator} - ${priceLabel}`}
          </Text>
        </div>

        <Link href="/cart">
          <Button
            isDisabled={minVotes ? votesCount < minVotes : false}
            id="cartbar-link-cart"
            label={cartTranslations?.add_to_cart_button}
            trailIcon="arrow"
            style={{ background: colors.background }}
            color={colors.primaryAccent}
          />
        </Link>
      </div>
    </div>
  )
}
